module.exports = __webpack_public_path__ + "img/1440.4aa79fec.jpg";